import { useState } from 'react';

function TextWithTooltipOnClick({ infoColor = '#969696', hoverOverText = '', hoverOverTextColor = 'text-', children }) {
    const [show, setShow] = useState(false);
    return (
        <div className="  flex items-center gap-2 w-fit ">
            <p className={`${hoverOverTextColor}  cursor-pointer font-bold `}>
                <span onMouseEnter={() => setShow(true)} onMouseLeave={() => setShow(false)}>
                    {' '}
                    {hoverOverText}
                </span>
            </p>
            <div className="relative">
                {show && (
                    <div className="absolute  flex  -left-36 top-3   ">
                        <div className="bg-grayBgNormal w-80 text-textPrimary rounded-lg shadow-tooltipShadow p-6">
                            {children}
                        </div>
                    </div>
                )}
            </div>
        </div>
    );
}

export default TextWithTooltipOnClick;
